import { useGuttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/hooks/useGuttagekonto';
import { managerV1BaseUrl } from '@/utils';
import { Body, Button } from '@e2n/ui/v2';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';

export function BackButton() {
  const { id } = useParams();
  const currentYear = dayjs().year();
  const { guttagekonto } = useGuttagekonto([id], currentYear);

  return (
    <>
      <Button variant="ghost" size="small" asChild>
        <a
          href={`${managerV1BaseUrl}/secure/mitarbeiter/detail.jsf?idMitarbeiter=${id}`}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </a>
      </Button>
      <Body size="md" weight="semibold">
        {guttagekonto.mitarbeiter.vorname} {guttagekonto.mitarbeiter.nachname}
      </Body>
    </>
  );
}
